import { IsPremiumUser, isLoggedIn } from 'shared/vidio_helpers';
import AhoyTracker from 'shared/ahoy_tracker';
import AhoyEvent from 'shared/ahoy_event';
import GTMTracker from 'shared/gtm_tracker';
import MobilePremiumSubscribeModal from 'mobile/components/premium_subscribe_modal'

export default class SubscriptionBanner {
  static show(data) {
    if (SubscriptionBanner.isBlockingBannerExist()) {
      return;
    }
    let premiumBanner = document.querySelector('.js-watchpage-premium-banner');
    let premiumSubscribeBanner = document.querySelector('.b-premium-subscribe-banner');
    let tvodRentalBlocker = document.querySelector('.tvod-rent-banner');

    if(premiumBanner !== null){
      SubscriptionBanner.replaceElementProductCatalog(data, false);
      SubscriptionBanner.changePremierTitleWhenInsufficientPackage();
      premiumBanner.classList.remove('hide');
      SubscriptionBanner.sendImpression(premiumBanner);
    }

    if(premiumSubscribeBanner !== null){
      SubscriptionBanner.replaceElementProductCatalog(data, true);
      SubscriptionBanner.changePremierTitleWhenInsufficientPackage();
      premiumSubscribeBanner.classList.remove('hide');
    }

    if (tvodRentalBlocker !== null) {
      SubscriptionBanner.changePremierTitleWhenInsufficientPackage();
      SubscriptionBanner.sendTvodBannerImpression(tvodRentalBlocker);
      if (!SubscriptionBanner.isUserLoggedIn()) {
        SubscriptionBanner.tvodBlockerShowLogin();
      }
    }
  }
  static hide() {
    let premiumBanner = document.querySelector('.js-watchpage-premium-banner');
    if(premiumBanner) {
      premiumBanner.classList.add('hide');
    }

    let premiumSubscribeBanner = document.querySelector('.b-premium-subscribe-banner');
    if(premiumSubscribeBanner) {
      premiumSubscribeBanner.classList.add('hide');
    }
  }

  static changePremierTitleWhenInsufficientPackage() {
    if(! IsPremiumUser.get()) {
      return;
    }

    let defaultPremiumBannerTitle = document.querySelector('.js-watchpage-premium-banner-title.banner--default');
    let mismatchPremiumBannerTitle = document.querySelector('.js-watchpage-premium-banner-title.banner--mismatch');

    if (defaultPremiumBannerTitle) {
      defaultPremiumBannerTitle.classList.add('hide');
    }

    if (mismatchPremiumBannerTitle) {
      mismatchPremiumBannerTitle.classList.remove('hide');
    }
  }

  static sendImpression(element) {
    element.querySelectorAll('.js-ahoy-manual[data-ahoy-impression]').forEach(impressionElement => {
      SubscriptionBanner.ahoyTracker(impressionElement).sendEventImpression();
    });
  }

  static sendTvodBannerImpression(element) {
    let el = element.querySelector('.js-ahoy-manual[data-ahoy-impression]');
    AhoyEvent.send('PLAYBACK::BLOCKER', JSON.parse(el.dataset.ahoyProps));
  }

  static ahoyTracker(element) {
    return new AhoyTracker(element);
  }

  static isBlockingBannerExist() {
    return document.querySelectorAll('.livestreaming__blocking-banner-container').length > 0;
  }

  static replaceElementProductCatalog(data,mobile) {
    try {
      let outsideSource = data.source;
      if(outsideSource == undefined) {
        return;
      }

      let elements = document.querySelectorAll('[data-ahoy-title=PRODUCT_CATALOG]');
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        let elSource = el.dataset.ahoyProps;
        let jsonProps = JSON.parse(elSource);
        if(jsonProps.source) {
          el.removeAttribute('data-ahoyloaded');
          jsonProps.source = outsideSource;
          el.dataset.ahoyProps = JSON.stringify(jsonProps);
          SubscriptionBanner.reloadTracker(el);
        }
      }
      if(mobile){
        SubscriptionBanner.refreshPremiumSubscribeModal();
      }

    } catch(err) {
      return;
    }
  }

  static tvodBlockerShowLogin() {
    let domLoginOffer = document.querySelector('.tvod-rent-banner__login-offer');
    if (domLoginOffer == null) return;
    domLoginOffer.classList.remove('hide');
  }

  static refreshPremiumSubscribeModal(){
    let modal = new MobilePremiumSubscribeModal();
    modal.destroy();
    modal.init();
  }

  static reloadTracker(element){
    if(element.classList.contains('js-gtm')){
      new GTMTracker(element).init();
    } else if(element.classList.contains('js-ahoy')){
      new AhoyTracker(element).init();
    }
  }

  static isUserLoggedIn() {
    return isLoggedIn();
  }
}
